import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { loginClient, logout } from "../actions/clientsActions";
import { listeSocietes, societeActuelle } from "../actions/societeActions";
import { saveVariableGlo } from "../actions/chariotActions";
import { chaineGet } from "../actions/chaineActions";
import { ParamParCliAction } from "../actions/paramAppActions";
import { useNavigate } from "react-router-dom";
import "../LoginClient.css"; // We'll create this CSS file
import { message } from "antd";

const LoginClient = ({ route }) => {
  const [choix_ser, setChoix_serv] = useState(false);
  const [nom_cli, setNomCli] = useState("");
  const [cod_cli, setCodCli] = useState("");
  const [rep, setRep] = useState("");
  const [wLangue, setWlangue] = useState("F");
  const [rester, setRester] = useState(true);
  const [del, setDel] = useState(false);
  const navigate = useNavigate();
  const logCli = useSelector((state) => state.client);
  const { client, erreur, loading } = logCli;
  const listeSoc = useSelector((state) => state.listeSocietes);
  const { societes, erreur: errSoc } = listeSoc;
  const dispatch = useDispatch();
  const cliServ = useSelector((state) => state.cliServState);
  const scaleValue = useRef(1);
  const lottieRef = useRef();

  const toggleCheckbox = () => {
    setRester(!rester);
  };

  const handlePress = () => {
    lottieRef.current?.play(); // You might replace Lottie with a web animation

    // Simplified animation for web
    scaleValue.current = 0.9;
    setTimeout(() => {
      scaleValue.current = 1;
    }, 100);
  };

  const login = () => {
    if (nom_cli === "" || cod_cli === "") {
      alert("Il faut remplir tous les champs!");
    } else {
      dispatch(loginClient(nom_cli, cod_cli, rester));

      setDel(false);
    }
  };

  useEffect(() => {
    console.log(client);
    setChoix_serv(false);
    dispatch(listeSocietes());

    dispatch(ParamParCliAction);

    if (client && client !== undefined) {
      handleNavigation(client.nivcli_cloud);
    } else if (client === undefined) {
      console.log(erreur);
    }
  }, [del, client]);

  const getData = async () => {
    try {
      const value = localStorage.getItem("persist");
      console.log("persist:" + value);
      if (value !== null) {
        if (value === "false") {
          dispatch(logout());
        } else {
          handleNavigation(client?.nivcli_cloud);
        }
      } else {
        handleNavigation(client?.nivcli_cloud);
      }
    } catch (e) {
      console.log("err store loc:" + e);
    }
  };

  const handleNavigation = (nivcli_cloud) => {
    if (nivcli_cloud === "R") {
      dispatch(societeActuelle(societes[0]));
      dispatch(saveVariableGlo(null));
      dispatch(ParamParCliAction());
      dispatch(chaineGet());
      navigate("/DemRepres", {
        state: {
          client: client.nom_cli,
          langue: wLangue,
          societe: societes?.find((s) => s.code_soc === client?.code_soc)
            ?.nom_soc,
          persist: rester,
        },
      });
    } else if (nivcli_cloud === "F") {
      dispatch(societeActuelle(societes[0]));
      dispatch(saveVariableGlo(null));
      navigate("/DemCliFinale", {
        state: {
          client: client.nom_cli,
          langue: wLangue,
          societe: societes?.find((s) => s.code_soc === client?.code_soc)
            ?.nom_soc,
          persist: rester,
        },
      });
    } else if (nivcli_cloud === "S") {
      dispatch(societeActuelle(societes[0]));
      setChoix_serv(true);
      dispatch(saveVariableGlo(null));
      dispatch(ParamParCliAction());
      dispatch(chaineGet());
    } else if (nivcli_cloud === "A" || nivcli_cloud === "O") {
      dispatch(societeActuelle(societes[0]));
      dispatch(saveVariableGlo(null));
      dispatch(ParamParCliAction());
      dispatch(chaineGet());
      navigate("/DemAdmin", {
        state: {
          client: client.nom_cli,
          langue: wLangue,
          societe: societes?.find((s) => s.code_soc === client?.code_soc)
            ?.nom_soc,
          persist: rester,
        },
      });
    }
  };

  return (
    <div className="image-background">
      <div className="keyboard-avoiding-view">
        <div className="contenu">
          <div className="header-login">
            <h1 className="welcome-text">بسم الله الرحمان الرحيم</h1>
            <h2 className="arabic-text">منصة التسوق عن بعد</h2>
          </div>

          <div className="input-container">
            <label className="label">Nom Client:</label>
            <input
              type="text"
              value={nom_cli}
              onChange={(e) => setNomCli(e.target.value)}
              className="input"
              placeholder="Entrez votre nom"
            />
          </div>

          <div className="input-container">
            <label className="label">Code Client:</label>
            <input
              type="password"
              value={cod_cli}
              onChange={(e) => setCodCli(e.target.value)}
              className="input"
              placeholder="Entrez votre code"
            />
          </div>

          <div className="checkbox-container">
            <input
              type="checkbox"
              id="stayConnected"
              checked={rester}
              onChange={toggleCheckbox}
              className="checkbox"
            />
            <label htmlFor="stayConnected" className="checkbox-label">
              Rester Connecté
            </label>
          </div>

          <div
            className="button-container"
            style={{ transform: `scale(${scaleValue.current})` }}
          >
            <button onClick={login} className="login-button">
              Connexion
            </button>
          </div>

          <button
            className="signup-button"
            onClick={() => navigate("/AjoutClient")}
          >
            <span className="signup-text">فــــتح حســــاب جــــديــــد</span>
          </button>

          <div className="language-container">
            <div className="language-option">
              <input
                type="radio"
                id="french"
                name="language"
                value="F"
                checked={wLangue === "F"}
                onChange={() => setWlangue("F")}
                className="radio-button"
              />
              <label htmlFor="french" className="language-text">
                Français
              </label>
            </div>
            <div className="language-option">
              <input
                type="radio"
                id="arabic"
                name="language"
                value="A"
                checked={wLangue === "A"}
                onChange={() => setWlangue("A")}
                className="radio-button"
                disabled
              />
              <label htmlFor="arabic" className="language-text">
                عربية
              </label>
            </div>
            <div className="language-option">
              <input
                type="radio"
                id="english"
                name="language"
                value="E"
                checked={wLangue === "E"}
                onChange={() => setWlangue("E")}
                className="radio-button"
                disabled
              />
              <label htmlFor="english" className="language-text">
                English
              </label>
            </div>
          </div>
        </div>
      </div>

      {choix_ser && (
        <div className="server-selection">
          <button
            className="server-button"
            onClick={() => {
              dispatch(saveVariableGlo(null));
              navigate("/dem-admin", {
                state: {
                  client: client.nom_cli,
                  langue: wLangue,
                  societe: societes?.find(
                    (s) => s.code_soc === client?.code_soc
                  )?.nom_soc,
                },
              });
            }}
          >
            Serveur Production
          </button>
          <button
            className="server-button"
            onClick={() => {
              dispatch(saveVariableGlo(null));
              navigate("/DemAdmin", {
                state: {
                  client: client.nom_cli,
                  langue: wLangue,
                  societe: societes?.find(
                    (s) => s.code_soc === client?.code_soc
                  )?.nom_soc,
                },
              });
            }}
          >
            Serveur Develop
          </button>
        </div>
      )}

      {loading && (
        <div className="spinner-overlay">
          <div className="spinner-container">
            <div className="spinner"></div>
            <p className="spinner-text">Veuillez patienter...</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginClient;
